import { combineReducers } from 'redux';
import appReducer from './app';
import modalReducer from './modal';
import editorReducer from './editor';
import filterReducer from './filter';
import tasksReducer from './tasks';
import testsReducer from './tests';
import userReducer from './user';

export default combineReducers({
	app: appReducer,
	modal: modalReducer,
	editor: editorReducer,
	filter: filterReducer,
	tasks: tasksReducer,
	tests: testsReducer,
	user: userReducer,
});
